import { render } from "./SidebarAdmin.vue?vue&type=template&id=0a188fac"
import script from "./SidebarAdmin.vue?vue&type=script&lang=js"
export * from "./SidebarAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__